import { FaPercent } from "react-icons/fa";
import { ReactComponent as MoneyFilled } from "../../../assets/img/MoneyFilled.svg";

import styled from "styled-components";
import React from "react";

const Button = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: ${({ border }) => border};
  color: ${({ color }) => color};
  border-radius: 14px;
  padding: 10px 16px 10px 24px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  align-content: center;
  align-self: center;
  font-weight: 600;
  font-size: 14;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;

  > svg {
    position: relative;
    top: -1px;
  }
`

function handleVariant(variant) {
  if (variant === 'discount') {
    return {
      backgroundColor: 'transparent',
      border: '1.6px solid #C8131B',
      color: '#C8131B', 
      icon: <FaPercent width={16} height={16}/>
    }
  } else if (variant === 'goto-payment') {
    return {
      backgroundColor: '#C8131B',
      border: '1.6px solid transparent',
      color: 'white', 
      icon: <MoneyFilled width={16} height={16}/>
    }
  }
}

export default function BalconyButton({ children, variant, ...props }) {
  const currentVariant = handleVariant(variant);
  
  return <Button
    backgroundColor={currentVariant.backgroundColor}
    border={currentVariant.border}
    color={currentVariant.color}
    {...props}
  >
    {currentVariant.icon}
    {children}
  </Button>
}